directionOverlay.draw = function() {};
directionOverlay.setMap(gMap.map);
directionsDisplay.setMap(gMap.map);

document.getElementById('direction-mode').addEventListener('click', function() {
  calculateAndDisplayRoute(directionsService, directionsDisplay);
});

google.maps.event.addListener(directions, 'dragend', function(){
  calculateAndDisplayRoute(directionsService, directionsDisplay);
});

function calculateAndDisplayRoute(directionsService, directionsDisplay) {
  var selectedMode = $('#direction-mode .active').attr('data-id');
  directionsService.route({
    origin: {lat: centerLat, lng: centerLng},
    destination: {lat: directions.position.lat(), lng: directions.position.lng()},
    travelMode: google.maps.TravelMode[selectedMode]
  }, function(response, status) {
    
    var directionsDistance = response.routes[0].legs[0].distance.text;
    var directionsDuration = response.routes[0].legs[0].duration.text;
    var directionsAddress = response.routes[0].legs[0].end_address;
    directions.infoWindow.setContent('<p>'+ directionsAddress +'<br>'+ directionsDistance + ' - ' + directionsDuration + '<p>');

    if (status == google.maps.DirectionsStatus.OK) {
      directionsDisplay.setDirections(response);
    } else {
      window.alert('Directions request failed due to ' + status);
    }
  });
}

$('#direction-mode a').click(function(event) {
  event.preventDefault();
  var selected = $(this).attr('data-id');
  $('#direction-mode a.active').removeClass('active');
  $(this).addClass('active');
});

$('#reset-draggable').click(function(event) {
  event.preventDefault();
  $('#shelf #draggable').show();
  $('#direction-mode').css('height', '0px');
  TweenLite.set('#draggable', {x:0, y:0});
  directionsDisplay.setMap(null);
  directions.setVisible(false);
});

Draggable.create("#draggable", {
  type:"x,y",
  bounds: document.getElementById("container"),
  throwProps:true,
  onDragEnd:function(e) {
    $('#shelf #draggable').hide();
    $('#direction-mode').css('height', '256px');
    directionsDisplay.setMap(gMap.map);
    var point = new google.maps.Point(e.pageX, e.pageY);
    var ll = directionOverlay.getProjection().fromContainerPixelToLatLng(point);
    directions.setVisible(true);
    directions.setPosition(ll);
    
    calculateAndDisplayRoute(directionsService, directionsDisplay);
  }
});